





























import gql from 'graphql-tag';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import LoadingSpinner from '@reciprocity/loading-spinner';
import { mapKeys, upperFirst } from 'lodash';
import ObjectMapper from '@/components/object_mapper/ObjectMapper.vue';

export default Vue.extend({
  name: 'ScopingMapperWrapper',
  components: {
    ObjectMapper,
    LoadingSpinner,
  },
  props: {
    programId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      csrfToken: 'csrfToken',
      apiEndpoints: 'objectMapperApiEndpoints',
      rawAvailableMapTypes: 'availableMapTypes',
      modelMeta: 'modelMeta',
    }),
    availableMapTypes(): any {
      const types = mapKeys(this.rawAvailableMapTypes, (_, key) => upperFirst(key));
      // Allow just Objectives to be mapped
      types['Objective'] = [this.rightColumnType];
      return types;
    },
    rightColumnType() {
      return {
        model: this.modelMeta['control'].modelSingular,
        plural: this.modelMeta['control'].modelPlural,
        singular: this.modelMeta['control'].modelSingular,
      };
    },
    leftColumnType() {
      return {
        model: this.modelMeta['objective'].modelSingular,
        plural: this.modelMeta['objective'].modelPlural,
        singular: this.modelMeta['objective'].modelSingular,
      };
    },
    items() {
      if (!this.programMappings) {
        return [];
      }
      return this.programMappings['objectives'];
    },
    loading(): boolean {
      return this.$apollo.queries.programMappings.loading;
    },
    extraPostData(): { [key: string]: string } {
      if (!this.programMappings) {
        return {};
      }

      return {
        program_id: this.programMappings.program.dbId,
      };
    },
  },
  apollo: {
    programMappings: {
      query: gql`
        query ProgramObjectives($programId: ID!) {
          node(id: $programId) {
            ... on Program {
              id
              dbId
              title {
                value
              }
              mappings {
                objectives {
                  edges {
                    node {
                      id
                      dbId
                      title {
                        value
                      }
                      status {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
      variables() {
        return { programId: this.programId };
      },
      update: result => {
        const getMappedFromResponse = (objectType: string) =>
          result.node.mappings[objectType].edges
            .filter(n => n.node.status.value === 'In Scope')
            .map(e => ({
              id: e.node.dbId,
              title: e.node.title.value,
              identifier: e.node.title.value,
              status: e.node.status.value,
            }));

        return {
          program: {
            dbId: result.node.dbId,
            title: result.node.title.value,
          },
          objectives: getMappedFromResponse('objectives'),
        };
      },
    },
  },
});
